<template>
  <div class="form-add">
    <div class="form-add-body">
      <el-form label-width="120px" :model="form" :rules="rules" ref="form">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="头像" prop="photo">
              <el-upload
                class="avatar-uploader"
                :action="url"
                :data="extraData"
                :show-file-list="false"
                :on-success="handleAvatarSuccess"
                :before-upload="beforeAvatarUpload">
                <el-image
                  style="width: 100px; height: 100px"
                  v-if="form.photo"
                  :src="form.photo"
                  fit="cover"></el-image>
                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
              </el-upload>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">
            <el-form-item label="签名展示" prop="signUrl">
              <el-image
                style="width: 260px; height: 100px"
                v-if="form.signUrl"
                :src="form.signUrl"
                :preview-src-list="[form.signUrl]"
                fit="cover"></el-image>
              <span v-else>暂无数据</span>
            </el-form-item>
          </el-col>-->
        </el-row>

        <el-row :gutter="20">
<!--          <el-col :span="12">
            <el-form-item label="学号" prop="studenId">
              <el-input size="small" maxLength="255" v-model="form.studenId" placeholder="请输入学号"></el-input>
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="姓名" prop="name">
              <el-input size="small" maxLength="255" v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="手机号码" prop="phone">
              <el-input size="small" maxLength="255" v-model="form.phone" placeholder="请输入手机号码"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="证件类型" prop="idcardType">
              <el-select size="small" v-model="form.idcardType" placeholder="请选择证件类型" style="width: 100%;">
                <el-option label="身份证" value="身份证"></el-option>
                <el-option label="军官证" value="军官证"></el-option>
                <el-option label="护照" value="护照"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="身份证号" prop="idcard">
              <el-input size="small" maxLength="255" v-model="form.idcard" placeholder="请输入身份证号"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="学历" prop="eduId">
              <el-select size="small" style="width: 100%" v-model="form.eduId" placeholder="请选择学历">
                <el-option v-for="x in eduList" :label="x.name" :value="x.id" :key="x.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="工作单位" prop="company">
              <el-input size="small" maxLength="255" v-model="form.company" placeholder="请输入工作单位"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="性别" prop="sex">
              <el-select size="small" v-model="form.sex" placeholder="请选择性别" style="width: 100%;">
                <el-option label="男" :value="1"></el-option>
                <el-option label="女" :value="0"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
<!--          <el-col :span="12">
            <el-form-item label="培训科目" prop="subjectId">
              <el-cascader
                size="small"
                style="width: 100%"
                v-model="form.subjectId"
                :options="treeOptions"
                emitPath="false"
                :props="{ checkStrictly: true, emitPath:false }"
                clearable
              ></el-cascader>
&lt;!&ndash;              <el-input size="small" maxLength="255" v-model="form.subjectName" placeholder="请选择培训科目" @focus="openType" ></el-input>&ndash;&gt;
            </el-form-item>
          </el-col>-->
          <el-col :span="12">
            <el-form-item label="学习平台" prop="learnPlatformSeqId">
              <el-select size="small" style="width: 100%" v-model="form.learnPlatformSeqId" placeholder="请选择学习平台">
                <el-option v-for="x in lpList" :label="x.learnPlatformName" :value="x.learnPlatformSeqId" :key="x.learnPlatformSeqId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="营销渠道">
              <el-select size="small" style="width: 100%" v-model="form.marSeqId" placeholder="请选择营销渠道">
                <el-option v-for="x in marList" :label="x.marName" :value="x.marSeqId" :key="x.marSeqId"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="地区" prop="areaCode">
              <el-cascader
                size="small"
                style="width: 100%"
                :show-all-levels="false"
                v-model="form.areaCode"
                :options="areaOptions"
                emitPath="false"
                :props="{ checkStrictly: true, emitPath:false }"
                clearable></el-cascader>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="支付情况" prop="payFeeStatus">
              <el-radio-group v-model="form.payFeeStatus">
                <el-radio :label="1">已支付</el-radio>
                <el-radio :label="0">未支付</el-radio>
              </el-radio-group>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="健康情况" prop="healthStatus">
              <el-select size="small" v-model="form.healthStatus" placeholder="请选择健康情况" style="width: 100%;">
                <el-option label="一般" value="0"></el-option>
                <el-option label="健康" value="1"></el-option>
                <el-option label="良好" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item label="报名时间" prop="createTime">
              <el-date-picker size="small" type="date" placeholder="选择报名时间" v-model="form.createTime" style="width: 100%;"></el-date-picker>
            </el-form-item>
          </el-col>

        </el-row>


      </el-form>
      <div slot="footer" class="dialog-footer" style="float: right;">
        <el-button size="small" @click="customCallback('back')">取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm()">保存</el-button>
      </div>
    </div>

    <!-- 选择 父级项目 -->
    <el-dialog :close-on-click-modal="false" title="选择父级项目" width="20vw" top="6vh" :visible.sync="openUpType" append-to-body>
      <div class="tree-con " style="margin: 0 auto">

        <div class="head-search">
          <el-input
            v-model="treeName"
            maxLength="15"
            placeholder="请输入"
            clearable
            size="small"
          >
            <el-button slot="append" icon="el-icon-search"></el-button>
          </el-input>
        </div>

        <div class="head-tree">
          <el-tree
            :data="treeOptions"
            :props="defaultProps"
            :filter-node-method="filterNode"
            :expand-on-click-node="false"
            ref="tree"
            node-key="value"
            :default-expanded-keys="treeArr"
            @node-click="handleNodeClick2"
          >
            <div class="custom-tree-node" slot-scope="{ node, data }">
              <i
                class="custom-tree-node-icon"
                :class="node.isLeaf ? 'el-icon-aim' : 'el-icon-folder-opened'"
              ></i>
              <span
                class="s_l custom-tree-node-name "
                :title="data.label"
                :style="{ 'font-weight': node.isLeaf ? '400' : 'bold' }"
              >{{ data.label }}</span
              >
            </div>
          </el-tree>
        </div>

      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitUpType">确 定</el-button>
        <el-button @click="cancelUpType">取 消</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  queryStudentDetail,
  queryAllArea,
  queryEdu
} from '../../../api/student'
import {
  selectAreaTree
} from '../../../api/subjectTree'
import {getMarketingChannelList, getLearnPlatformList} from "../../../api/userMG";
export default {
  name: "addStudent",
  props: {
    item: {
      type: Object,
      default: {}
    }
  },
  data () {
    // 自定义手机号规则
    var checkMobile = (rule, value, callback) => {
      const regMobile = /^1[123456789]\d{9}$/
      if (regMobile.test(value)) {
        return callback()
      }
      // 返回一个错误提示
      callback(new Error('请输入正确的手机号码'))
    }
    //身份证号格式校验
    var isCardId = (rule, value, callback) => {
      if (!value) {
        return new Error("请输入身份证号)");
      } else {
        if (this.form.idcardType == '身份证') {
          const reg =
            /^\d{6}(18|19|20)?\d{2}(0[1-9]|1[0-2])(([0-2][1-9])|10|20|30|31)\d{3}(\d|X|x)$/;
          const card = reg.test(value);
          if (!card) {
            callback(new Error("身份证号格式有误！"));
          }

          const weights = [7, 9, 10, 5, 8, 4, 2, 1, 6, 3, 7, 9, 10, 5, 8, 4, 2];
          let sum = 0;
          for (let i = 0; i < 17; i++) {
            sum += parseInt(this.form.idcard.charAt(i)) * weights[i];
          }
          const remainder = sum % 11;
          const checkCodeMap = { 0: 1, 1: 0, 2: "X", 3: 9, 4: 8, 5: 7, 6: 6, 7: 5, 8: 4, 9: 3, 10: 2 };
          const checkCode = checkCodeMap[remainder]; // 检查校验码是否匹配

          if (checkCode.toString().toUpperCase() === this.form.idcard.charAt(17).toUpperCase()) {
            callback();
          } else {
            callback(new Error("身份证号无效！"));
          }

        } else {
          callback();
        }
      }
    }
    return {
      dialogVisible: false,
      disabled: false,
      loading: false, //是显示加载
      url: '/api/student/upload',
      extraData: {
        sftx: '1'
      },
      openUpType: false,
      // 表单参数
      form: {
        createTime: '',
        photo: '',
      },
      // 表单校验
      rules: {
        areaCode: [
          { required: true, message: '请选择地区', trigger: 'blur' }
        ],
        name: [
          { required: true, message: '请输入姓名', trigger: 'blur' }
        ],
        idcardType: [
          { required: true, message: '请选择证件类型', trigger: 'blur' }
        ],
        idcard: [
          { required: true, message: "请输入身证件号码", trigger: "blur" },
          { validator: isCardId, trigger: "blur" }
        ],
        eduId: [
          { required: true, message: '请选择学历', trigger: 'blur' }
        ],
        company: [
          { required: true, message: '请输入工作单位', trigger: 'blur' }
        ],
        sex: [
          { required: true, message: '请输入性别', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号码', trigger: 'blur' },
          { validator: checkMobile, trigger: 'blur' }
        ],
        subjectId: [
          { required: true, message: '请选择培训科目', trigger: 'blur' }
        ],
        learnPlatform: [
          { required: true, message: '请输入学习平台', trigger: 'blur' }
        ],
        payFeeStatus: [
          { required: true, message: '请选择支付情况', trigger: 'blur' }
        ],
        healthStatus: [
          { required: true, message: '请选择健康情况', trigger: 'blur' }
        ],
        createTime: [
          { required: true, message: '请选择报名时间', trigger: 'blur' }
        ],

      },
      treeArr: [],  // 默认展示第二级树节点
      treeName: undefined,
      treeOptions: undefined,
      defaultProps: {
        children: "children",
        label: "label"
      },
      // 树状图 双击事件参数
      treeClickCnt: 0,
      treeClickTimeout: null,

      // 地区数据
      areaOptions: [],
      // 营销渠道
      marList: [],
      // 学习平台
      lpList: [],
      // 学历数据
      eduList: []
    }
  },
  watch: {
    // 根据名称筛选部门树
    treeName(val) {
      this.$refs.tree.filter(val);
    }
  },
  created () {
    this.initDate();
  },
  activated() {
    this.initDate();
  },
  methods: {
    initDate() {
      this.selectAreaTree()
      this.queryAllArea()
      this.findMarList()
      this.findLearnPlatList()
      this.findEdu()
      if (this.item != undefined && JSON.stringify(this.item) != '{}') {
        console.log('11111')
        this.queryStudentDetail()
      } else {
        console.log('33333')
        var date = new Date();
        this.form = {
          createTime: date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + (date.getDate()),
          photo: ''
        }
      }
    },
    // 查询 学历
    findEdu() {
      queryEdu().then(res => {
        if (res.code == 200) {
          this.eduList = res.data;
        }
      })
    },
    // 查询 学习平台
    findLearnPlatList() {
      getLearnPlatformList(JSON.stringify({query: {status: 1}})).then(res => {
        if (res.code == 200) {
          this.lpList = res.data.list
        }
      })
    },
    // 查询 营销渠道
    findMarList() {
      getMarketingChannelList(JSON.stringify({query: {status: 1}})).then(res => {
        if (res.code == 200) {
          this.marList = res.data.list
        }
      })
    },
    // 查询 地区树
    queryAllArea() {
      queryAllArea({}).then(res => {
        if (res.code == 200) {
          var list = res.data;
          list.forEach(item => {
            if (item.children.length > 0) {
              item.children.forEach(x => {
                if (x.children.length > 0) {
                  x.children.forEach(y => {
                    y.children = undefined
                  })
                } else {
                  x.children = undefined
                }
              })
            } else {
              item.children = undefined;
            }
          })

          this.areaOptions = list;
        }
      })
    },
    // 查询 科目树
    selectAreaTree() {
      selectAreaTree({}).then(res => {
        if (res.code == 200) {
          this.treeOptions = res.data;
          res.data.forEach(x => {
            this.treeArr.push(x.value)
          })
        }
      })
    },
    // 查询详情数据
    queryStudentDetail() {
      queryStudentDetail(this.item).then(res => {
        if (res.code == 200) {
          this.form = res.data;
        }
      })
    },

    // 筛选树节点
    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },
    // 打开项目选择框
    openType() {
      this.openUpType = true
    },
    // 选择项目 节点点击事件
    handleNodeClick2(data) {
      // 如果点击的id不相同，则重置点击次数
      if (data.value != this.form.subjectId) {
        this.treeClickCnt = 0;
      }
      this.form.subjectId = data.value
      this.form.subjectName = data.label
      this.treeClickCnt++;

      // 注册清空点击次数计时器任务
      window.clearTimeout(this.treeClickTimeout);
      this.treeClickTimeout = window.setTimeout(() => {
        this.treeClickCnt = 0;
      }, 300);

      // 连续点击多次则不做任何事情
      if (this.treeClickCnt > 2) return;
      // 点击一次时单击事件
      if (this.treeClickCnt == 1) {
        // 单击事件
        console.log('单击');
      }
      // 点击两次时双击事件
      if (this.treeClickCnt == 2) {
        // 双击事件
        console.log('双击');
        this.submitUpType()
      }

    },
    // 保存项目
    submitUpType() {
      this.openUpType = false;
    },
    cancelUpType() {
      this.form.parentId = undefined
      this.form.parentName = undefined
      this.openUpType = false;
    },
    handleAvatarSuccess(res, file) {
      /* URL.createObjectURL(file.raw) */
      this.form.photo = res.data.url;
    },
    beforeAvatarUpload(file) {
      console.log('file===', file);
      var isJPG = false;
      if (file.type === 'image/png' || file.type === 'image/jpeg') {
        isJPG = true;
      }
      const isLt2M = file.size / 1024 / 1024 < 2;

      if (!isJPG) {
        this.$message.error('上传头像图片只能是 JPG 或 PNG 格式!');
      }
      if (!isLt2M) {
        this.$message.error('上传头像图片大小不能超过 2MB!');
      }
      return isJPG && isLt2M;
    },

    // 保存 数据
    // 编辑、增加页面保存方法
    submitForm() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          var data = {
            type: 'saveForm', // 关闭 'refresh',// 执行父页面刷新
            item: this.form
          }
          this.$emit('sonHandleCallback', data)
        } else {
          return false
        }
      })
    },

    // 关闭编辑、增加弹出框
    customCallback(type, item) {
      var data = {
        type: type, // 关闭 'refresh',// 执行父页面刷新
        item: item
      }
      this.$emit('sonHandleCallback', data)
    }

  }
}
</script>

<style scoped>
.form-add {
  padding: 0 20px 20px 20px;
  height: 100%;
  overflow: auto;
}
.form-add .form-add-body {
  height: 100%;
  padding: 0;
  overflow-x: hidden;
  overflow-y: auto;
}

/* 头像上传 */
/deep/ .avatar-uploader .el-upload {
  height: 100px;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
/deep/ .avatar-uploader .el-upload:hover {
  border-color: #409EFF;
}
/deep/ .avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
/deep/ .avatar {
  width: 100px;
  height: 100px;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/views/goods/student/addStudent.vue